import { normalize, schema } from 'normalizr';

export const entity = 'batchSettlements';
export const entitySchema = new schema.Entity(entity);
export const listNormalizer = (result) => normalize(result, [entitySchema]);
